var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{attrs:{"id":_vm.name}},[_vm._t("default"),_c('b-tooltip',{attrs:{"target":_vm.name,"disabled":!_vm.active,"placement":_vm.placement}},[_vm._v("\n    "+_vm._s(_vm.message)+"\n  ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }